import { render, staticRenderFns } from "./canTheWheelBeRiggedCard.vue?vue&type=template&id=776652f8&scoped=true&"
import script from "./canTheWheelBeRiggedCard.vue?vue&type=script&lang=js&"
export * from "./canTheWheelBeRiggedCard.vue?vue&type=script&lang=js&"
import style0 from "./canTheWheelBeRiggedCard.vue?vue&type=style&index=0&id=776652f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776652f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willy/code/fake-the-wheel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776652f8')) {
      api.createRecord('776652f8', component.options)
    } else {
      api.reload('776652f8', component.options)
    }
    module.hot.accept("./canTheWheelBeRiggedCard.vue?vue&type=template&id=776652f8&scoped=true&", function () {
      api.rerender('776652f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/cards/canTheWheelBeRiggedCard.vue"
export default component.exports